import { EmissionClient } from '../../../EmissionRequest';
import { me } from '../../../../../constants/paymentIssuerSource';
import PaymentIssuer from '../../../../helperTypes/PaymentIssuer';

/**
 * Returns an EmissionClient instance representing the payment issuer, and the appropiate
 * fields will be overwritten depending on the provided paymentIssuerSource.
 *
 * @param originalClient - The information related to the original client
 * @param paymentIssuerSource - The source that will be used to create the issuer
 * @param paymentIssuer - The issuer data that will overwrite the original client
 */
export default function createPaymentIssuer(
  originalClient: EmissionClient,
  paymentIssuerSource: string,
  paymentIssuer: PaymentIssuer,
): EmissionClient {
  if (paymentIssuerSource === me) {
    return {
      ...originalClient,
      codCli: '',
    };
  }
  return {
    ...originalClient,
    codCli: '',
    id: paymentIssuer.idNumber,
    idType: paymentIssuer.idType,
    genderId: paymentIssuer.gender,
    birthdate: paymentIssuer.birthday,
    firstName: paymentIssuer.names,
    lastName: paymentIssuer.lastNames,
    phone1: paymentIssuer.phoneNumber,
    email: paymentIssuer.email,
  };
}
